<template>
  <modal
    name="bank-movement-view-modal"
    height="auto"
    class="md:m-6"
    adaptive
    scrollable
  >
    <b-loading
      v-model="loading"
      :is-full-page="false"
    />
    <div>
      <div>
        <bank-movement-info
          v-bind="$props"
          @close="hide()"
        />
      </div>
      <div>
        <comments
          v-bind="$props"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import Comments from './comments.vue';
import BankMovementInfo from './bank-movement-info.vue';

export default {
  data() {
    return {
      active: this.isModalActive,
    };
  },
  components: {
    Comments,
    BankMovementInfo,
  },
  computed: {
    loading() {
      return this.$store.state.movements.loadingMovement ||
             this.$store.state.movements.loadingComments ||
             this.$store.state.users.loadingAuthorizerUser;
    },
  },
  props: {
    isModalActive: {
      type: Boolean,
      default: false,
    },
    movementId: {
      type: Number,
      default: null,
    },
    flipButtonsStyle: {
      type: Boolean,
      default: false,
    },
    entityId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    show() {
      this.$modal.show('bank-movement-view-modal');
    },
    hide() {
      this.$modal.hide('bank-movement-view-modal');
    },
  },
};
</script>>
<style>
  .vm--overlay[data-modal="bank-movement-view-modal"] + .vm--modal {
    height: auto !important;
  }
</style>
